module.exports = __webpack_public_path__ + "img/sbsbicon.e2e73a16.svg";